var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-detail"},[_c('img',{class:!_vm.value && _vm.valid? 'disabled' : '',attrs:{"src":_vm.currentIcon}}),_c('input',{class:{
      'detail-input': true,
      dark: _vm.isDarkMode,
      'detail-red-input': !_vm.valid,
    },attrs:{"type":"text","placeholder":_vm.fullname ? _vm.$t('reserve.fullname_ph') : _vm.$t('reserve.name_ph')},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }